<template>
  <a-layout-sider :collapsed="collapsed" :trigger="null" collapsible>
    <a-menu
      v-if="gotPermissions"
      theme="dark"
      mode="inline"
      :openKeys="openKeys"
      :selectedKeys="selectedKeys"
      @openChange="$emit('open-change', $event)"
    >
      <template v-for="menu in sidenavMenu" :key="menu.subName">
        <template v-if="menu.active">
          <template v-if="!menu.children">
            <a-menu-item
              v-if="loggedinUserPermissions?.indexOf(menu.permission) > -1"
              :key="menu.subName"
              @click="$emit('goto', menu)"
            >
              <template #icon>
                <span class="material-symbols-outlined">{{ getIconName(menu.subName) }}</span>
              </template>
              {{ menu.name }}
            </a-menu-item>
          </template>

          <template v-else>
            <a-sub-menu
              v-if="loggedinUserPermissions?.indexOf(menu.permission) > -1"
              :key="menu.subName"
            >
              <template #icon>
                <span class="material-symbols-outlined">{{ getIconName(menu.subName) }}</span>
              </template>
              <template #title>{{ menu.name }}</template>

              <template v-for="subMenu in menu.children" :key="subMenu.subName">
                <template v-if="subMenu.isLabel">
                  <a-menu-item class="menu-label" :key="subMenu.subName">
                    {{ subMenu.name }}
                  </a-menu-item>
                </template>

                <template v-else>
                  <template v-if="loggedinUserPermissions?.indexOf(subMenu.permission) > -1">
                    <a-menu-item :key="subMenu.subName" @click="$emit('goto-submenu', subMenu)">
                      {{ subMenu.name }}
                    </a-menu-item>
                  </template>
                </template>
              </template>
            </a-sub-menu>
          </template>
        </template>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
import { defineComponent } from 'vue'

const iconMap = {
  masters: 'database',
  tracker: 'monitoring',
  liability: 'description',
  challans: 'list',
  compliances: 'verified_user',
  reports: 'article',
  document: 'assignment',
  settings: 'settings',
  administration: 'account_circle',
  returns: 'description',
  reconcilation: 'note',
  review: 'description',
  docrepo: 'assignment',
  onboarding: 'how_to_reg'
}

export default defineComponent({
  name: 'AppSideNav',
  props: {
    collapsed: {
      type: Boolean,
      required: true
    },
    gotPermissions: {
      type: Boolean,
      required: true
    },
    openKeys: {
      type: Array,
      required: true
    },
    selectedKeys: {
      type: Array,
      required: true
    },
    sidenavMenu: {
      type: Array,
      required: true
    },
    loggedinUserPermissions: {
      type: Array,
      required: true
    }
  },
  emits: ['open-change', 'goto', 'goto-submenu'],
  methods: {
    getIconName(subName) {
      if (subName === 'expenses' || subName === 'income') {
        return 'receipt'
      }

      return iconMap[subName] || 'article'
    }
  }
})
</script>
